import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meetings } from './meetings.interface';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.scss'],
})
export class MeetingsComponent implements OnInit {
  @Input() meeting!: Meetings;
  @Input() type: string = 'past';
  engagementId:any = "";
  constructor(private route: ActivatedRoute, private router: Router,) {}

  ngOnInit(): void {
    // console.log(this.meeting);
    this.engagementId = this.route.snapshot.paramMap.get('id');
  }
  goto(linkName:any, meeting: Meetings){
    if(this.engagementId != "")
    {
      if(linkName == "Governance Meetings"){
        this.router.navigate([`/governance-meetings`, {id: this.engagementId, meetingId: meeting.uId}]);
      }
    }
  
  }
}
